<header class="header"></header>

<div class="d-flex mx-auto pt-md-10 content justify-content-center">
  <router-outlet />
</div>

<footer></footer>
